import { Box, Container } from "@mui/material";

import Head from "next/head";
import { TokenExchangeCallbackWidget } from "@components/okta/TokenExchangeCallbackWidget";
import { prefixWithBasePath } from "../../../lib/asset";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "react-i18next";

export default function CallbackPage() {
  const { t } = useTranslation(["common", "login"]);
  return (
    <>
      <Head>
        <title>{`myCargill - ${t("login:login.title")}`}</title>
        <meta
          name="description"
          content={t("login:login.title") || undefined}
        />
      </Head>
      <Box
        sx={{
          flex: 1,
          backgroundImage: `url(${prefixWithBasePath(
            "/assets/images/mycargill-landing.webp"
          )})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          width: "100%",
        }}
      >
        <Container
          sx={{
            minHeight: "670px",
            padding: `40px 12px`,
            display: "flex",
            gap: { lg: 20, md: 10, sm: 4 },
            justifyContent: "center",
            alignItems: "center",
            mb: 16,
          }}
        >
          <TokenExchangeCallbackWidget />
        </Container>
      </Box>
    </>
  );
}

export const getStaticProps = async ({ locale }: any) => {
  return {
    props: {
      // even though OktaSignInWidget is dynamically imported
      // you must include `login` so that its translations are available for its internal use
      // otherwise you will see `login:login.xyz` missing strings or errors
      ...(await serverSideTranslations(locale, ["login", "common", "welcome"])),
    },
  };
};
